import React, { useState } from "react";
import { IconSearch } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { LangConstant, SystemConstant } from "const";
import { useBranchRequestUpdate } from "hooks";
import { BRANCH_REQUEST_STATUS } from "const/system.const";

const Heading = ({
  searchInput,
  choosedStatus,
  onChangeSearchInput,
  onChangeStatusDropdown,
  checkedUsers,
  setCheckedUsers,
  refetch,
}) => {
  const { t: getLabel } = useTranslation([LangConstant.NS_COMMON, LangConstant.NS_LOGIN]);

  const { updateBranchRequest } = useBranchRequestUpdate();

  const [isOpenConfirmCancleReject, setIsOpenConfirmCancleReject] = useState(false);

  const handleCancleReject = () => {
    updateBranchRequest({
      branch_request_ids: checkedUsers,
      status: SystemConstant.BRANCH_REQUEST_STATUS.PENDING.status,
      refetch: refetch,
      onClose: () => {
        setIsOpenConfirmCancleReject(false);
        setCheckedUsers([]);
      },
    });
  };

  const DialogConfirmCancleReject = () => {
    if (!isOpenConfirmCancleReject) return null;
    return (
      <>
        <div className="modal-backdrop fade show" />
        <div className="modal modal-sm show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header justify-content-center">
                <h5 className="modal-title fw-bold">Xác nhận gỡ trạng thái từ chối</h5>
              </div>
              <div className="modal-body text-center">
                <p>Bạn có muốn gỡ trạng thái từ chối không?</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-link link-secondary me-auto"
                  onClick={() => setIsOpenConfirmCancleReject(false)}
                >
                  Huỷ
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleCancleReject}
                >
                  Xác nhận
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
      <DialogConfirmCancleReject />

      <div className="d-flex align-items-center" style={{ width: "680px", maxWidth: "100%" }}>
        <div className="input-icon w-100">
          <input
            type="text"
            className="form-control"
            defaultValue={searchInput}
            onChange={onChangeSearchInput}
            placeholder={getLabel(LangConstant.P_ADD_NEW_USER)}
          />
          <span className="input-icon-addon">
            <IconSearch size={16} />
          </span>
        </div>
        {choosedStatus == BRANCH_REQUEST_STATUS.ALL.status && (
          <div style={{ marginLeft: 8, width: 320 }}>
            <select
              className="form-select"
              onChange={onChangeStatusDropdown}
              value={choosedStatus}
            >
              {Object.values(SystemConstant.BRANCH_REQUEST_STATUS)
                .filter(f => f != SystemConstant.BRANCH_REQUEST_STATUS.ACCEPTED)
                .map(userStatus => (
                  <option key={userStatus.status} value={userStatus.status}>
                    {userStatus.label}
                  </option>
                ))}
            </select>
          </div>
        )}
      </div>

      {(choosedStatus == BRANCH_REQUEST_STATUS.REJECTED.status ||
        choosedStatus == BRANCH_REQUEST_STATUS.ALL.status) && (
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-primary"
            disabled={checkedUsers.length <= 0}
            onClick={() => setIsOpenConfirmCancleReject(true)}
          >
            Gỡ từ chối {checkedUsers.length > 0 ? "(" + checkedUsers.length + ")" : ""}
          </button>
        </div>
      )}
    </div>
  );
};

export default Heading;
